// this file is automatically generated by git.version.ts script
export const versions = {version: "1.0.0", revision: "23272bb", branch: "Component-refactor"};